import * as React from 'react';

export const ArrowDropDown = props => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.7659 8.77958C18.1386 9.15235 18.1386 9.75669 17.7659 10.1295L12.6749 15.2204C12.3021 15.5932 11.6978 15.5932 11.325 15.2204L6.23409 10.1295C5.86131 9.75669 5.86131 9.15235 6.23409 8.77958C6.60688 8.40681 7.21117 8.40681 7.58395 8.77958L12 13.1955L16.4159 8.77958C16.7887 8.40681 17.3931 8.40681 17.7659 8.77958Z"
      fill="#64748B"
    />
  </svg>
);
